'use client'

import type { ProfileSearchRecord } from '@/features/profiles/types/profile-search'
import { RankingCardSkeleton } from '@/features/ranking'
import { NotFoundAlert } from '@/shared/ui/NotFoundAlert'

import { ProfileSearchCard } from './ProfileSearchCard'

interface ProfileSearchResultsProps {
  records: ProfileSearchRecord[]
  isLoading: boolean
  onProfileClick: (record: ProfileSearchRecord) => void
}

export function ProfileSearchResults({
  records,
  isLoading,
  onProfileClick
}: ProfileSearchResultsProps) {
  if (isLoading) {
    return (
      <div className="flex flex-col gap-2" aria-busy="true" aria-live="polite">
        <RankingCardSkeleton />
        <RankingCardSkeleton />
        <RankingCardSkeleton />
      </div>
    )
  }

  if (records.length === 0) {
    return (
      <NotFoundAlert
        title="Nenhum perfil encontrado"
        text="Tente ajustar os filtros (nome, escola ou série) para encontrar outros estudantes."
      />
    )
  }

  return (
    <ul
      className="flex flex-col list-none p-0 m-0 overflow-auto max-h-[60vh] [&>li]:border-b-2 [&>li]:border-jacaranda/30 [&>li:last-child]:border-b-0"
      aria-label="Resultados da busca"
    >
      {records.map(record => (
        <li key={record.uid}>
          <ProfileSearchCard
            record={record}
            onClick={() => onProfileClick(record)}
          />
        </li>
      ))}
    </ul>
  )
}
